var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import TextInput from './TextInput';
import Checkbox from './Checkbox';
import Select from './Select';
import Button from './Button';
import Error from './Error';
import ToggleCheckbox from './ToggleCheckbox';
import OptionList from './OptionList';
import HtmlBlock from './HtmlBlock';
import PasswordInput from './PasswordInput';
import SubmitButton from './SubmitButton';
import { createClassListFromModifiers } from '../../../core/utils/class-helper';
var components = {
    PasswordInput: PasswordInput,
    TextInput: TextInput,
    Checkbox: Checkbox,
    ToggleCheckbox: ToggleCheckbox,
    Select: Select,
    Button: Button,
    SubmitButton: SubmitButton,
    OptionList: OptionList,
    HtmlBlock: HtmlBlock,
};
var FormElement = /** @class */ (function (_super) {
    __extends(FormElement, _super);
    function FormElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormElement.prototype.render = function () {
        var _this = this;
        var className = this.props.formElement.getComponentName();
        if (!components.hasOwnProperty(className)) {
            return null;
        }
        var C = components[className];
        if ('HtmlBlock' === className) {
            return (React.createElement("div", null,
                React.createElement(C, { formElement: this.props.formElement, isLoading: this.props.isLoading })));
        }
        var classList = __spreadArray([
            'c-form-element'
        ], createClassListFromModifiers('c-form-element', this.props.formElement.config.formElementClassModifiers));
        var hasError = this.props.form.hasError(this.props.formElement.name);
        if (hasError) {
            classList.push('c-form-element--has-error');
        }
        return (React.createElement("div", { className: classList.join(' ') },
            this.renderLabel(),
            React.createElement(C, { formElement: this.props.formElement, onChange: function (value) { return _this.onChange(value); }, hasError: hasError, isLoading: this.props.isLoading }),
            this.renderError()));
    };
    FormElement.prototype.renderError = function () {
        var error = this.props.form.getError(this.props.formElement.name);
        if (!error) {
            return null;
        }
        return React.createElement(Error, { error: error });
    };
    FormElement.prototype.renderLabel = function () {
        if (!this.props.formElement.shouldRenderLabel()) {
            return null;
        }
        return (React.createElement("label", { className: "c-form-element__label" }, this.props.formElement.label || ''));
    };
    FormElement.prototype.onChange = function (value) {
        this.props.onChange(this.props.formElement.name, value);
    };
    return FormElement;
}(React.Component));
export default FormElement;
